import * as Sentry from "@sentry/vue";
import { httpClientIntegration } from "@sentry/integrations";

export default defineNuxtPlugin((nuxtApp) => {
  const sentry = useRuntimeConfig().public.sentry;

  if (!sentry.dsn) {
    return;
  }

  const app = nuxtApp.vueApp;

  Sentry.init({
    app,
    environment: sentry.environment,
    release: sentry.release,
    dsn: sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/.+\.smartcomm\.ai\/api/,
        ],
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      httpClientIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.3,
    // Session Replay
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.10,
  });
});
